exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n  .src-components-ConfirmDialog-___styles__modal___2nd_3 .src-components-ConfirmDialog-___styles__body___3Ge5_ {\n    text-align: center;\n    min-height: auto;\n  }\n\n/* Confirmation modal should be displayed above other modals */\n\n.src-components-ConfirmDialog-___styles__confirmationDialog___1AKLY.modal {\n    z-index: 2001;\n  }\n\n.src-components-ConfirmDialog-___styles__confirmationDialog___1AKLY.modal-backdrop {\n    z-index: 2000;\n  }\n\n\n", ""]);

// Exports
exports.locals = {
	"modal": "src-components-ConfirmDialog-___styles__modal___2nd_3",
	"body": "src-components-ConfirmDialog-___styles__body___3Ge5_",
	"confirmationDialog": "src-components-ConfirmDialog-___styles__confirmationDialog___1AKLY"
};